import { gql } from "@apollo/client";

export const submitHealthQuestionnaire = gql`
 mutation SubmitHealthQuestionnaire($id: String!, $flow: String!) {
  submitHealthQuestionnaire(id: $id, flow: $flow) {
    rejected
    messages
    needsConfirmation
  }
}
`;